import styles from "./Brands.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useEffect, useState } from "react";
import { StoresTypes } from "../../../../api/types/products.types";
import ProductsService from "../../../../api/services/products.service";
import LocalizedLink from "../../../common/localized-link/LocalizedLink";

const BrandsSection = () => {
  const [brands, setBrands] = useState<StoresTypes[]>([]);

  useEffect(() => {
    const getData = async () => {
      const res = await ProductsService.getALLStores(1, 100);
      setBrands(res.data.data);
    };

    getData();
  }, []);

  return (
    <section className={styles.brands}>
      <div className={styles.slider}>
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 0 }}
          loop={true}
          speed={6000}
          className={styles.swiperContainer}
          breakpoints={{
            1920: { slidesPerView: 16 },
            1680: { slidesPerView: 14 },
            1440: { slidesPerView: 12 },
            1024: { slidesPerView: 8 },
            576: { slidesPerView: 5 },
            0: { slidesPerView: 4 },
          }}
        >
          {brands.map((b, i) => (
            <SwiperSlide key={i} className={styles.slide}>
              <LocalizedLink
                to={`/store-products/${b.id}`}
                className={styles.img}
              >
                {b?.logo_url ? (
                  <img src={b?.logo_url} alt={`Partner ${i}`} />
                ) : (
                  <p>{b?.name}</p>
                )}
              </LocalizedLink>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BrandsSection;
